'use es6';

var Promise = window.Promise;
export { Promise };